import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
import withStateReinit from 'hocs/WithStateReinit';
// Core components
import Card from 'components/core/Card';
import TextField from 'components/core/TextField';
// Custom
import { cpmOnDemandAccessDataShape, errorShape } from 'constants/PropTypesShapes';
import { buildFormErrors, cpmOnDemandAccessSendPriceGridConstraints } from 'utils/Forms';
import FormDialogTemplate from 'components/templates/FormDialogTemplate';
import FormHelper from 'components/misc/FormHelper';

class OnDemandSendPriceGridForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      onDemand,
      fields: { email },
      onErrorsChange,
      onValidate,
    } = this.props;

    const errors = buildFormErrors({ email }, cpmOnDemandAccessSendPriceGridConstraints);

    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate(onDemand, { email });
      return true;
    }

    return false;
  }

  render() {
    const {
      fields: { email },
      errors,
      onFieldsChange,
    } = this.props;

    return (
      <FormDialogTemplate errors={errors}>
        <div className="row">
          <div className="col-12">
            <div className="d-flex">
              <FormHelper
                elements={[
                  {
                    content: (
                      <LocalizedMessage id="help.onDemand.sendPriceGridEmail" />
                    ),
                  },
                ]}
              />
              <div style={{ flex: 1 }}>
                <Card>
                  <div className="row">
                    <React.Fragment>
                      <div className="col-12 col-lg-8">
                        <TextField
                          label={<LocalizedMessage id="field.email" />}
                          margin="none"
                          required
                          type="email"
                          name="email"
                          errorText={_get(errors, 'email')}
                          value={email}
                          onChange={(value) => onFieldsChange({ email: value })}
                        />
                      </div>
                    </React.Fragment>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </FormDialogTemplate>
    );
  }
}

OnDemandSendPriceGridForm.propTypes = {
  onDemand: cpmOnDemandAccessDataShape.isRequired,
  operationError: errorShape, // eslint-disable-line react/no-unused-prop-types
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

OnDemandSendPriceGridForm.defaultProps = {
  operationError: null,
  errors: null,
};

const mapFieldsToProps = {
  email: {
    defaultValue: '',
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps.onDemand,
  operationError: ownProps.operationError,
});

const mapStateToProps = (state) => ({
  operationError: state.cpmCarparkParkingCategory.sendPriceGridToCustomer.error,
});

module.exports = compose(
  connect(mapStateToProps),
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false),
  withStateReinit(['sendCarparkPriceGridToCustomer']),
)(OnDemandSendPriceGridForm);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/onDemand/OnDemandSendPriceGridForm.js